import axios from 'axios'
import qs from 'qs'
// import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV == 'production' ? "http://210.41.222.190" : "http://210.41.222.190", // api的base_url
  timeout: 15000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
  config["Content-Type"]="application/json"
  let loginToken = localStorage.getItem("loginToken");
  if (loginToken && loginToken != 'undefined') {
    config.headers['APP-Auth-Token'] = loginToken;
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非200是抛错 可结合自己业务进行修改
    */
    const res = response.data
    if (res.errorNo != '0') {
      // 401:未登录;
      if (res.errorNo == '401' || res.errorNo == 401) {
        //location.reload()// 为了重新实例化vue-router对象 避免bug
      }

      return response.data
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    return Promise.reject(error)
  }
)


export default {
  getSessionId() {
    return service.get('/common/kaptcha')
  },
  login(data){
    return service.post('/login',qs.stringify(data))
  },
  ilabxLogin(data) {
    return service.post('/api/ilabx/token', qs.stringify(data));
  },
  ilabxUpload(data) {
    return service.put('/admin/score/insertScore', data);
  }
}